// mutation 常量

export const SET_MPVUEINFO = 'SET_MPVUEINFO'
export const SET_PROFILE = 'SET_PROFILE'
export const SET_TITLE = 'SET_TITLE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js